import { render, staticRenderFns } from "./UploadFilePage.vue?vue&type=template&id=25f77251&scoped=true"
import script from "./UploadFilePage.vue?vue&type=script&lang=js"
export * from "./UploadFilePage.vue?vue&type=script&lang=js"
import style0 from "./UploadFilePage.vue?vue&type=style&index=0&id=25f77251&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f77251",
  null
  
)

export default component.exports